import {
    VOTEBOX_AGAINST_COLOR,
    VOTEBOX_NEUTRAL_OPTION_COLOR,
    VOTEBOX_SUCCESS_COLOR,
} from "../voteboxTokens";

const FOR_PROPOSITION_ID = "1";
const AGAINST_PROPOSITION_ID = "2";

// "Pour" in green, "Contre" in red, abstention and the options after it in grey.
export function getDeliberationOptionColor(propositionId: string): string {
    if (FOR_PROPOSITION_ID === propositionId) {
        return VOTEBOX_SUCCESS_COLOR;
    }

    if (AGAINST_PROPOSITION_ID === propositionId) {
        return VOTEBOX_AGAINST_COLOR;
    }

    return VOTEBOX_NEUTRAL_OPTION_COLOR;
}
